import React from 'react';

const LockIcon = () => (
  <svg viewBox="0 0 13 15" preserveAspectRatio="xMinYMin" className="sl-lock-icon">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-20.000000, -772.000000)" fill="#FFFFFF">
        <g transform="translate(0.000000, 760.000000)">
          <path d="M26.5,12 C24.1058333,12 22.1666667,13.9178571 22.1666667,16.2857143L22.1666667,18.4285714 L20,18.4285714 L20,27 L33,27 L33,18.4285714 L30.8333333,18.4285714 L30.8333333,16.2857143 C30.8333333,13.9178571 28.8941667,12 26.5,12 L26.5,12 Z M26.5,14.1428571 C27.7891667,14.1428571 28.6666667,15.0107143 28.6666667,16.2857143 L28.6666667,18.4285714 L24.3333333,18.4285714 L24.3333333,16.2857143 C24.3333333,15.0107143 25.2108333,14.1428571 26.5,14.1428571 Z M25.4166667,20.5714286 L27.5833333,20.5714286 L27.5833333,24.8571429 L25.4166667,24.8571429 L25.4166667,20.5714286 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default LockIcon;
